import { useState } from "react";
import { MessageCircle, Phone, X, Plus } from "lucide-react";
import { BRAND } from "@/data/site";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const mobile = BRAND.phone || "+447367025779";
  const landline = BRAND.landline || "";
  const mobileDigits = mobile.replace(/[^\d+]/g, "");
  const landlineDigits = landline.replace(/[^\d]/g, "");
  const waNumber = mobileDigits.replace(/^\+/, "");
  const waMessage = encodeURIComponent("Hi Green Connect, I'd like a quote for some work.");

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
      {open && (
        <>
          <a
            data-testid="float-whatsapp"
            href={`https://wa.me/${waNumber}?text=${waMessage}`}
            target="_blank" rel="noreferrer"
            className="flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-2xl hover:scale-105 transition-transform"
            style={{ borderRadius: "999px" }}
          >
            <MessageCircle size={20}/>
            <span className="font-display uppercase tracking-widest text-xs">WhatsApp</span>
          </a>
          <a
            data-testid="float-call-mobile"
            href={`tel:${mobileDigits}`}
            className="flex items-center gap-3 bg-[#8DE038] text-[#050806] pl-4 pr-5 py-3 shadow-2xl hover:scale-105 transition-transform"
            style={{ borderRadius: "999px" }}
          >
            <Phone size={20}/>
            <span className="font-display uppercase tracking-widest text-xs">Mobile</span>
          </a>
          {landline && (
            <a
              data-testid="float-call-landline"
              href={`tel:${landlineDigits}`}
              className="flex items-center gap-3 bg-[#F0F4F1] text-[#050806] pl-4 pr-5 py-3 shadow-2xl hover:scale-105 transition-transform"
              style={{ borderRadius: "999px" }}
            >
              <Phone size={20}/>
              <span className="font-display uppercase tracking-widest text-xs">Landline</span>
            </a>
          )}
        </>
      )}
      <button
        data-testid="float-toggle"
        onClick={() => setOpen(!open)}
        aria-label={open ? "Close contact" : "Contact us"}
        className="w-14 h-14 bg-[#8DE038] text-[#050806] flex items-center justify-center shadow-2xl hover:scale-110 transition-transform"
        style={{ borderRadius: "999px" }}
      >
        {open ? <X size={22}/> : <Plus size={22}/>}
      </button>
    </div>
  );
}
